module.exports = __webpack_public_path__ + "static/NOSPR-da61c651d93eddd5724a2f3548ccadb1.png";